import { ChangeDetectionStrategy, Component, input, output, effect } from '@angular/core';
import { isUndefined } from 'lodash-es';

@Component({
	selector: 'app-toggle-buttons',
	templateUrl: './toggle-buttons.component.html',
	styleUrls: ['./toggle-buttons.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleButtonsComponent<T> {
	readonly options = input.required<T[]>();
	readonly value = input<T | undefined>(undefined);
	readonly labelFunction = input<(value: T) => string>((value) => `${value}`);
	readonly small = input<boolean>(false);

	readonly valueChange = output<T>();

	constructor() {
		effect(() => {
			const value = this.value();
			if (!isUndefined(value)) return;
			if (this.options().length <= 0) return;
			this.valueChange.emit(this.options()[0]);
		});
	}

	select(option: T) {
		this.valueChange.emit(option);
	}
}
